import type { Handler } from './handler';
import type { ApiFetchRoulettesPort } from './ports/api-fetch-roulettes.port';
import type { RouletteListResult } from '~/types/roulette';
import { resolveAdapter } from '~/adapters/registry';

export const fetchRoulettesHandler: Handler<Params, Ports, Result> = async (
  _params,
  ports = {
    apiFetchRoulettes: resolveAdapter('apiFetchRoulettes'),
  },
) => {
  return await ports.apiFetchRoulettes.handle();
};

type Params = void;

type Ports = { apiFetchRoulettes: ApiFetchRoulettesPort };

type Result = Promise<RouletteListResult>;
